<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ params.value }}</span>
    </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  computed: {
    chipColor () {
      return (value) => {
        if (value === true) return 'success'
        else if (value === false) return 'danger'
        else if (value === '5/5') return 'success'
        else if (value === '4/5') return 'success'
        else if (value === '3/5') return 'warning'
        else if (value === '2/5') return 'warning'
        else if (value === '1/5') return 'danger'
        else if (value === '0/5') return 'danger'
        
        else if (value === 'Parent approved ⟶ Awaiting child') return 'danger'
        else if (value === 'Child assigned') return 'success'

        else if (value === 'Pending ⟶ Awaiting approval') return ''
        else if (value === 'Approved ⟶ Awaiting invoicing') return 'danger'

        else if (value === 'Advance paid ⟶ Awaiting transport') return 'warning'
        else if (value === 'Advance invoice ⟶ Awaiting Payment') return 'danger'
        else if (value === 'Invoice paid ⟶ Awaiting transport') return 'warning'
        else if (value === 'Final Invoice ⟶ Awaiting Payment') return 'danger'
        else if (value === 'Invoice paid ⟶ Awaiting transport') return 'warning'
        else if (value === 'Invoice done ⟶ Awaiting payment') return 'danger'

        else if (value === 'Transport assigned') return 'warning'
        else if (value === 'Transport in progress') return '#4775d1'
        else if (value === 'Delivered and Paid') return 'success'
        else if (value === 'Delivered and not paid') return 'warning'
        else return ''
      }
    }
  }
}
</script>

<style lang="scss">
/*.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}*/
</style>
